import _ from "lodash";
import moment from "moment";

export default function (event) {
  const regWindow = _.get(
    event,
    "registration.window._id",
    "manual:unreleased",
  );

  // Possible statuses:
  // 'automatic' 'manual:finished' 'manual:released' 'manual:unreleased'
  if (regWindow == "automatic") {
    const subscriptionStart = moment(
      _.get(event, "registration.subscriptionStart"),
    );
    const subscriptionEnd = moment(
      _.get(event, "registration.subscriptionEnd"),
    );
    const now = moment();
    if (subscriptionStart.isValid()) {
      if (subscriptionStart.isAfter(now)) {
        return { name: "unreleased", date: subscriptionStart };
      }

      if (subscriptionEnd.isValid()) {
        if (subscriptionEnd.isBefore(now)) {
          return { name: "ended", date: subscriptionEnd };
        } else {
          return { name: "released", date: subscriptionEnd };
        }
      }

      return { name: "released" };
    }
  }

  if (regWindow == "manual:finished") {
    return { name: "ended" };
  }

  if (regWindow == "manual:released") {
    return { name: "released" };
  }

  return { name: "unreleased" };
}



// WEBPACK FOOTER //
// ./src/helpers/EventStatus.js